
// Transpiler for older browsers
import 'core-js/stable'
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime'
import 'current-script-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from './common/api.service'
import VueI18n from 'vue-i18n'
/** Css and js all page */
import './assets/css/style.css'
import './assets/css/ck-content.css'
import 'bootstrap-vue/dist/bootstrap-vue.common.min'

/** import element ui */
import 'element-ui/lib/theme-chalk/index.css'
import JQuery from 'jquery'
import './customELComponent'
/** Global Components */
import './globalComponents.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faSubway, faAlignJustify } from '@fortawesome/free-solid-svg-icons/'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import CKEditor from '@ckeditor/ckeditor5-vue'
import VueImgOrientationChanger from 'vue-img-orientation-changer'
import ja from '@/lang/ja.json'
import vn from '@/lang/vn.json'
import en from '@/lang/en.json'

/** lazy load image */
import VueLazyload from 'vue-lazyload'
import { has, hasGroup } from '@/common/permission'
import VueGtm from 'vue-gtm'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/images/error.png'),
  loading: require('./assets/images/loading.gif'),
  attempt: 1
})

library.add(faUserSecret, faTwitter, faSubway, faAlignJustify)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
// Vue.use(CKEditor)
Vue.use(VueImgOrientationChanger)
Vue.use(VueI18n)
Vue.prototype._$ = JQuery
Vue.prototype.$perm = {
	has: (permissionCode, authorityCode) => has(store.getters.rolePermissionGroup, permissionCode, authorityCode),
	hasGroup: (permissionGroupCode) => hasGroup(store.getters.rolePermissionGroup, permissionGroupCode)
}
const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

ApiService.init()

// below code to redirect route depend on domain
const host = window.location.hostname
const DOMAIN_CLIENT = process.env.VUE_APP_DOMAIN_CLIENT
const GTM_ID = process.env.VUE_APP_GTM_ID

const routerApp = () => {
  let routes
  if (host === DOMAIN_CLIENT) {
    routes = router.getRouteMember()
    if (GTM_ID !== '' && GTM_ID !== undefined) {
      Vue.use(VueGtm, {
        id: GTM_ID,
        defer: false,
        enabled: true,
        debug: false,
        loadScript: true,
        vueRouter: routes
      })
    }
  } else {
    routes = router.getRouteNotFound()
  }
  return routes
}

const i18n = new VueI18n({
  locale: 'ja',
  messages: {
    'ja': ja,
    'vn': vn,
    'en': en
  }
})
window.app = new Vue({
  router: routerApp(),
  store,
  EventBus,
  i18n,
  render: h => h(App)
}).$mount('#app')
